import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router} from '@angular/router';
import { Observable } from 'rxjs/Observable';

@Injectable()
export class AuthGuard implements CanActivate {
	constructor(private router: Router){
		//
	}

	canActivate(next: ActivatedRouteSnapshot,state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
		let apiToken = sessionStorage.getItem('api-token');

		if(!apiToken){
			this.router.navigate(['/login']);
			return false;
		}else{
			return true;
		}
	}
}



// WEBPACK FOOTER //
// /var/www/nodejs/nextstore/src/app/guards/auth.guard.ts